(() => {
  if (window.__c_product_contact_link_initialized) return;
  window.__c_product_contact_link_initialized = true;

  // 直前に表示していたバリアント画像のメディアID（一般写真に切替えても保持）
  let lastVariantMediaId = '';

  // data-media-sku-map（メディアID→品番。カラーコードは Liquid 側で除去済み）をパースする
  function parseMediaSkuMap(link) {
    try {
      return JSON.parse(link.getAttribute('data-media-sku-map') || '{}');
    } catch (e) {
      return {};
    }
  }

  // 全リンクの media-sku-map を統合（メディアIDがバリアント画像か判定するため）
  function buildUnionMap(links) {
    const union = {};
    links.forEach((link) => {
      const map = parseMediaSkuMap(link);
      Object.keys(map).forEach((id) => {
        union[id] = map[id];
      });
    });
    return union;
  }

  // 現在ギャラリーで表示中(is-selected)のメディアIDを返す
  function getSelectedMediaId() {
    const selected = document.querySelector('.product__media-item.is-selected[data-media-id]');
    return selected ? selected.getAttribute('data-media-id') : '';
  }

  // 表示中メディアがバリアント画像なら lastVariantMediaId を更新（一般写真は据え置き）
  function rememberCurrentVariant(unionMap) {
    const mediaId = getSelectedMediaId();
    if (mediaId && unionMap[mediaId]) {
      lastVariantMediaId = mediaId;
    }
  }

  // 渡す品番を解決：①表示中の色 →②直前に見た色 →③先頭の品番(data-first-sku)
  function resolveSku(link) {
    const map = parseMediaSkuMap(link);
    const mediaId = getSelectedMediaId();
    if (mediaId && map[mediaId]) return map[mediaId];
    if (lastVariantMediaId && map[lastVariantMediaId]) return map[lastVariantMediaId];
    return link.getAttribute('data-first-sku') || '';
  }

  // href を現在の品番で更新する（subject等の既存パラメータは保持）
  function updateHref(link) {
    const sku = resolveSku(link);
    const url = new URL(link.getAttribute('href'), window.location.origin);
    if (sku) {
      url.searchParams.set('sku', sku);
    } else {
      url.searchParams.delete('sku');
    }
    link.href = url.pathname + url.search;
  }

  // ギャラリーの is-selected 変化を監視し、最後に見たバリアント画像を記憶する
  function observeGallery(unionMap) {
    const galleries = document.querySelectorAll('.product__media-list');
    if (!galleries.length) return;
    const observer = new MutationObserver(() => rememberCurrentVariant(unionMap));
    galleries.forEach((gallery) => {
      observer.observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  }

  // 初期化：クリック時に表示中（または直前）の色のSKUへ href を確定する
  function init() {
    const links = document.querySelectorAll('[data-product-contact-link]');
    if (!links.length) return;

    const unionMap = buildUnionMap(links);
    rememberCurrentVariant(unionMap); // 初期表示色を記憶
    observeGallery(unionMap);

    // click を document へ委譲（product:rerender でリンクが差し替わっても動くように）
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-product-contact-link]');
      if (link) updateHref(link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
